'use client'

import { useState } from 'react'
import clsx from 'clsx'

type Props = {
	items: string[]
	className?: string
	selected?: string[]
	onChange?: (value: string[]) => void
}

export default function Toggle({ items, className, selected, onChange }: Props) {
	const [localSelected, setLocalSelected] = useState(0)

	const handleClick = (index: number) => {
		if (onChange) {
			onChange([items[index]])
		} else {
			setLocalSelected(index)
		}
	}

	const selectedIndex = selected ? items.indexOf(selected[0]) : localSelected

	return (
		<div
			className={clsx('grid rounded-md overflow-hidden', className)}
			style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}
		>
			{items.map((item, index) => (
				<button
					key={item}
					type="button"
					aria-label={item}
					onClick={() => handleClick(index)}
					aria-pressed={selectedIndex === index}
					className={clsx(
						'toggle',
						selectedIndex === index
							? 'text-white before:translate-y-0'
							: 'text-blue-dark before:translate-y-full'
					)}
				>
					<span>{item}</span>
				</button>
			))}
		</div>
	)
}
